import React from 'react'

import { Toast } from 'primereact/toast'
import { Dropdown } from 'primereact/dropdown'
import { Chips } from 'primereact/chips'
import { InputTextarea } from 'primereact/inputtextarea'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Dialog } from 'primereact/dialog'

import TermosPublicacoesAtividadeService from '../../app/service/TermosPublicacoesAtividadeService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import UsuarioService from '../../app/service/UsuarioService'

// Responsáveis recebem as atividades em rodízio (na ordem da lista); interessados entram em todas
const TIPOS_USUARIO = [
  { label: 'Responsável', value: 'R' },
  { label: 'Interessado', value: 'I' }
];

const MODOS_CASAMENTO = [
  { label: 'Pelo menos um dos termos', value: 'QUALQUER' },
  { label: 'Todos os termos', value: 'TODOS' }
];

class TermosPublicacaoAtividade extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      termos: [],
      titulos: [],
      usuariosEmpresa: [],
      //Formulário do termo em edição
      modalTermo: false,
      termoCodigo: null,
      listaTermos: [],
      modoCasamento: 'QUALQUER',
      orgao: '',
      tipoComunicacao: '',
      titulo: null,
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      usuario: null,
      tipoUsuario: null
    }

    this.usuariosTemp = [];

    this.termosPublicacoesAtividadeService = new TermosPublicacoesAtividadeService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.usuarioService = new UsuarioService();

    this.acoesTermo = this.acoesTermo.bind(this);
    this.acoesUsuario = this.acoesUsuario.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.consultarTermos();
      this.consultarTitulosAtividades();
      this.consultarUsuariosEmpresa();
    }
  }

  consultarTermos = async () => {
    await this.termosPublicacoesAtividadeService.listar(this.props.empresaId)
      .then(response => {
        this.setState({ termos: response.data });
      }).catch(error => {
        this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: `Erro ao consultar termos: ${error}`, life: 4000 });
      })
  }

  consultarTitulosAtividades = async () => {
    await this.tituloAtividadeService.listarParaParametros(this.props.empresaId)
      .then(response => {
        this.setState({ titulos: response.data });
      }).catch(error => {
        this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'Erro ao consultar títulos de atividade', life: 4000 });
      })
  }

  consultarUsuariosEmpresa = async () => {
    await this.usuarioService.listarUsuariosEmpresa(this.props.empresaId)
      .then(response => {
        this.setState({ usuariosEmpresa: response.data });
      }).catch(error => {
        this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'Erro ao consultar usuários', life: 4000 });
      })
  }

  novoTermo = () => {
    this.usuariosTemp = [];
    this.setState({
      modalTermo: true,
      termoCodigo: null,
      listaTermos: [],
      modoCasamento: 'QUALQUER',
      orgao: '',
      tipoComunicacao: '',
      titulo: null,
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      usuario: null,
      tipoUsuario: null
    });
  }

  editarTermo = (termoConsulta) => {
    this.usuariosTemp = (termoConsulta.usuarios || []).map(u => ({
      codigoUsuario: u.usuario.codigo,
      nome: u.usuario.nome,
      tipoUsuario: u.tipoUsuario,
      tipoExibir: u.tipoUsuario === 'R' ? 'Responsável' : 'Interessado'
    }));
    // O título vem da mesma lista do Dropdown para ficar selecionado
    const titulo = termoConsulta.titulo
      ? (this.state.titulos.find(t => t.codigo === termoConsulta.titulo.codigo) || termoConsulta.titulo)
      : null;
    this.setState({
      modalTermo: true,
      termoCodigo: termoConsulta.codigo,
      listaTermos: termoConsulta.termos || [],
      modoCasamento: termoConsulta.modoCasamento || 'QUALQUER',
      orgao: termoConsulta.orgao || '',
      tipoComunicacao: termoConsulta.tipoComunicacao || '',
      titulo: titulo,
      descricao: termoConsulta.descricao || '',
      dtLimite: termoConsulta.dtLimite,
      dtFatal: termoConsulta.dtFatal,
      usuario: null,
      tipoUsuario: null
    });
  }

  excluirTermo = async (termoConsulta) => {
    await this.termosPublicacoesAtividadeService.excluir(termoConsulta.codigo)
      .then(() => {
        this.toast.show({ severity: 'success', summary: 'Criar Atividade Termos', detail: 'Termo excluído com sucesso', life: 4000 });
        this.consultarTermos();
      }).catch(error => {
        this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: `Falha ao excluir termo: ${error}`, life: 4000 });
      })
  }

  adicionarUsuario = () => {
    if (this.state.usuario == null) {
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'Nenhum usuário foi selecionado', life: 4000 });
      return;
    }

    if (this.state.tipoUsuario == null) {
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'Selecione se o usuário é Responsável ou Interessado', life: 4000 });
      return;
    }

    const usuarioJaAdicionado = this.usuariosTemp.some(u => u.codigoUsuario === this.state.usuario.codigo);
    if (usuarioJaAdicionado) {
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'Este usuário já foi adicionado para este termo', life: 4000 });
      return;
    }

    this.usuariosTemp.push({
      codigoUsuario: this.state.usuario.codigo,
      nome: this.state.usuario.nome,
      tipoUsuario: this.state.tipoUsuario,
      tipoExibir: this.state.tipoUsuario === 'R' ? 'Responsável' : 'Interessado'
    });

    this.setState({ modalTermo: true, usuario: null, tipoUsuario: null });
  }

  excluirUsuario = (usuario) => {
    this.usuariosTemp = this.usuariosTemp.filter(u => u.codigoUsuario !== usuario.codigoUsuario);
    this.setState({ modalTermo: true });
  }

  //Muda a posição do usuário na lista (a ordem dos responsáveis é a ordem do rodízio)
  moverUsuario = (usuario, deslocamento) => {
    const indice = this.usuariosTemp.findIndex(u => u.codigoUsuario === usuario.codigoUsuario);
    const destino = indice + deslocamento;
    if (indice < 0 || destino < 0 || destino >= this.usuariosTemp.length) {
      return;
    }
    const lista = [...this.usuariosTemp];
    [lista[indice], lista[destino]] = [lista[destino], lista[indice]];
    this.usuariosTemp = lista;
    this.setState({ modalTermo: true });
  }

  diasOuNulo = (valor) => {
    if (valor === null || valor === undefined || String(valor).trim() === '') {
      return null;
    }
    return parseInt(valor, 10);
  }

  salvarTermo = async () => {
    const termos = (this.state.listaTermos || []).map(t => t.trim()).filter(t => t !== '');
    if (termos.length === 0) {
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'Informe ao menos um termo', life: 4000 });
      return;
    }

    if (this.state.titulo == null) {
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'O título da atividade não foi informado', life: 4000 });
      return;
    }

    if (!this.usuariosTemp.some(u => u.tipoUsuario === 'R')) {
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'Informe ao menos um responsável', life: 4000 });
      return;
    }

    const dtLimite = this.diasOuNulo(this.state.dtLimite);
    const dtFatal = this.diasOuNulo(this.state.dtFatal);
    if (dtFatal !== null && dtFatal < (dtLimite || 0)) {
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: 'O prazo fatal não pode ser anterior à data limite', life: 4000 });
      return;
    }

    const dto = {
      codigo: this.state.termoCodigo,
      empresa: { codigo: this.props.empresaId },
      termos: termos,
      modoCasamento: this.state.modoCasamento,
      orgao: this.state.orgao.trim() || null,
      tipoComunicacao: this.state.tipoComunicacao.trim() || null,
      titulo: this.state.titulo,
      descricao: this.state.descricao,
      dtLimite: dtLimite,
      dtFatal: dtFatal,
      usuarios: this.usuariosTemp.map(u => ({
        usuario: { codigo: u.codigoUsuario },
        tipoUsuario: u.tipoUsuario
      }))
    };

    const salvar = this.state.termoCodigo == null
      ? this.termosPublicacoesAtividadeService.cadastrar(dto)
      : this.termosPublicacoesAtividadeService.alterar(dto);

    await salvar.then(() => {
      this.toast.show({ severity: 'success', summary: 'Criar Atividade Termos', detail: 'Termo salvo com sucesso', life: 4000 });
      this.setState({ modalTermo: false });
      this.consultarTermos();
    }).catch(error => {
      const detalhe = error.response && error.response.data && error.response.data.userMessage
        ? error.response.data.userMessage : `${error}`;
      this.toast.show({ severity: 'error', summary: 'Criar Atividade Termos', detail: `Falha ao salvar termo: ${detalhe}`, life: 5000 });
    })
  }

  acoesTermo(rowData) {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text"
                tooltip="Editar Termo"
                onClick={() => this.editarTermo(rowData)}
                tooltipOptions={{ position: 'top' }}
                style={{ width: '20px', height: '10px' }} />
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Termo"
                onClick={() => this.excluirTermo(rowData)}
                tooltipOptions={{ position: 'top' }}
                style={{ width: '20px', height: '10px' }} />
      </React.Fragment>
    );
  }

  acoesUsuario(rowData) {
    return (
      <React.Fragment>
        <Button icon="pi pi-arrow-up" className="p-button-rounded p-button-text"
                tooltip="Subir na ordem do rodízio"
                onClick={() => this.moverUsuario(rowData, -1)}
                tooltipOptions={{ position: 'top' }}
                style={{ width: '20px', height: '10px' }} />
        <Button icon="pi pi-arrow-down" className="p-button-rounded p-button-text"
                tooltip="Descer na ordem do rodízio"
                onClick={() => this.moverUsuario(rowData, 1)}
                tooltipOptions={{ position: 'top' }}
                style={{ width: '20px', height: '10px' }} />
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Usuário"
                onClick={() => this.excluirUsuario(rowData)}
                tooltipOptions={{ position: 'top' }}
                style={{ width: '20px', height: '10px' }} />
      </React.Fragment>
    );
  }

  termosResumidos(rowData) {
    const termos = (rowData.termos || []).join(rowData.modoCasamento === 'TODOS' ? ' + ' : ' ou ');
    const resumo = termos.length > 80 ? `${termos.substring(0, 80)}…` : termos;
    return <span title={termos}>{resumo || 'Sem termos (edite a regra)'}</span>;
  }

  responsaveis(rowData) {
    return (rowData.usuarios || []).filter(u => u.tipoUsuario === 'R').map(u => u.usuario.nome).join(', ');
  }

  prazo(dias) {
    return dias === null || dias === undefined ? 'No recebimento' : `${dias} dia(s)`;
  }

  render() {
    return (
      <>
        <Toast ref={(el) => this.toast = el} />
        <Dialog header="Criar Atividade Termos"
                visible={this.props.visible}
                style={{ width: '60vw' }}
                footer={
                  <div>
                    <Button label="Fechar"
                            className="p-button-secondary p-button-text"
                            onClick={this.props.onHide} />
                  </div>
                }
                onHide={this.props.onHide}>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <Button label="Novo Termo"
                        style={{ width: '100%', height: '32px' }}
                        onClick={this.novoTermo}
                        className="p-button-primary p-button-text" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <DataTable value={this.state.termos}
                           emptyMessage="Nenhum termo cadastrado"
                           size="small"
                           showGridlines>
                  <Column header="Termos" body={this.termosResumidos}></Column>
                  <Column field="orgao" header="Órgão"></Column>
                  <Column field="tipoComunicacao" header="Tipo de Comunicação"></Column>
                  <Column field="titulo.tituloExibir" header="Título"></Column>
                  <Column header="Data Limite" body={(rowData) => this.prazo(rowData.dtLimite)}></Column>
                  <Column header="Prazo Fatal" body={(rowData) => this.prazo(rowData.dtFatal != null ? rowData.dtFatal : rowData.dtLimite)}></Column>
                  <Column header="Responsáveis (rodízio)" body={(rowData) => this.responsaveis(rowData)}></Column>
                  <Column field="proximoResponsavel" header="Próximo"></Column>
                  <Column body={this.acoesTermo} exportable={false} style={{ minWidth: '8rem' }} header="Ações"></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </Dialog>

        {/**Formulário de Termo */}
        <Dialog header={this.state.termoCodigo == null ? 'Novo Termo' : 'Editar Termo'}
                visible={this.state.modalTermo}
                style={{ width: '50vw' }}
                footer={
                  <div>
                    <Button label="Salvar"
                            className="p-button-primary p-button-text"
                            onClick={this.salvarTermo} />
                    &nbsp;
                    <Button label="Fechar"
                            className="p-button-secondary p-button-text"
                            onClick={() => this.setState({ modalTermo: false })} />
                  </div>
                }
                onHide={() => this.setState({ modalTermo: false })}>
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label>Termos (digite e tecle Enter)</label>
                <Chips value={this.state.listaTermos}
                       onChange={e => this.setState({ listaTermos: e.value })}
                       separator=","
                       allowDuplicate={false}
                       style={{ width: '100%' }}
                       className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>A publicação deve conter</label>
                <Dropdown value={this.state.modoCasamento}
                          options={MODOS_CASAMENTO}
                          style={{ width: '100%', height: '32px' }}
                          onChange={e => this.setState({ modoCasamento: e.value })}
                          optionLabel="label"
                          className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
            </div>
            <div className="col-md-12">
              <small className="p-d-block" style={{ marginTop: '-10px', marginBottom: '10px' }}>
                A comparação ignora maiúsculas, acentos e espaços repetidos.
              </small>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Órgão</label>
                <InputText id="orgaoTermo" style={{ width: '100%', height: '32px' }}
                           type="text"
                           autoComplete="none"
                           value={this.state.orgao}
                           onChange={e => this.setState({ orgao: e.target.value })}
                           className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Tipo de Comunicação</label>
                <InputText id="tipoComunicacaoTermo" style={{ width: '100%', height: '32px' }}
                           type="text"
                           autoComplete="none"
                           value={this.state.tipoComunicacao}
                           onChange={e => this.setState({ tipoComunicacao: e.target.value })}
                           className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
            </div>
            <div className="col-md-12">
              <small className="p-d-block" style={{ marginTop: '-10px', marginBottom: '10px' }}>
                Opcionais, como no Comunica (ex.: "2ª Vara Cível", "Intimação"). Preenchidos, a publicação também precisa conter o texto no órgão/tipo. Em branco: qualquer.
              </small>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Data limite (dias após o recebimento)</label>
                <InputText id="dtLimite" style={{ width: '100%', height: '32px' }}
                           type="text"
                           keyfilter="pint"
                           autoComplete="none"
                           value={this.state.dtLimite == null ? '' : this.state.dtLimite}
                           onChange={e => this.setState({ dtLimite: e.target.value })}
                           className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Prazo fatal (dias após o recebimento)</label>
                <InputText id="dtFatal" style={{ width: '100%', height: '32px' }}
                           type="text"
                           keyfilter="pint"
                           autoComplete="none"
                           value={this.state.dtFatal == null ? '' : this.state.dtFatal}
                           onChange={e => this.setState({ dtFatal: e.target.value })}
                           className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
            </div>
            <div className="col-md-12">
              <small className="p-d-block" style={{ marginTop: '-10px', marginBottom: '10px' }}>
                Dias corridos. Data limite em branco: o próprio dia do recebimento. Prazo fatal em branco: a data limite.
              </small>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Título da Atividade</label>
                <Dropdown value={this.state.titulo}
                          options={this.state.titulos}
                          style={{ width: '100%', height: '32px' }}
                          optionLabel="tituloExibir"
                          dataKey="codigo"
                          filter showClear filterBy="tituloExibir"
                          onChange={e => this.setState({ titulo: e.target.value })}
                          id="tituloAtividadeTermo"
                          className="p-inputtext-sm p-d-block p-mb-1" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Descrição da Atividade</label>
                <InputTextarea id="descricaoAtividadeTermo"
                               type="text"
                               style={{ width: '100%' }}
                               value={this.state.descricao}
                               onChange={e => this.setState({ descricao: e.target.value })}
                               className="p-inputtext-sm p-d-block p-mb-1"
                               rows={3} cols={30} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="form-group">
                <label>Usuário</label>
                <Dropdown inputId="usuarioTermo"
                          value={this.state.usuario}
                          options={this.state.usuariosEmpresa}
                          style={{ width: '100%', height: '32px' }}
                          onChange={(e) => this.setState({ usuario: e.value })}
                          filter showClear filterBy="nome"
                          optionLabel="nome" />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Tipo</label>
                <Dropdown inputId="tipoUsuarioTermo"
                          value={this.state.tipoUsuario}
                          options={TIPOS_USUARIO}
                          style={{ width: '100%', height: '32px' }}
                          onChange={(e) => this.setState({ tipoUsuario: e.value })}
                          optionLabel="label" />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>&nbsp;</label>
                <Button label="Adicionar"
                        style={{ width: '100%', height: '32px' }}
                        onClick={this.adicionarUsuario}
                        className="p-button-primary p-button-text" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <DataTable value={this.usuariosTemp}
                           emptyMessage=" "
                           size="small"
                           showGridlines>
                  <Column field="nome" header="Usuário"></Column>
                  <Column field="tipoExibir" header="Tipo"></Column>
                  <Column body={this.acoesUsuario} exportable={false} style={{ minWidth: '10rem' }} header="Ações"></Column>
                </DataTable>
                <small className="p-d-block">
                  Com mais de um responsável, cada publicação vai para o próximo da lista (rodízio, de cima para baixo).
                  Interessados entram em todas as atividades. A atividade é sempre criada pelo usuário ILAW, com status
                  Criada, no subgrupo Publicação do grupo de trabalho do processo.
                </small>
              </div>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}

export default TermosPublicacaoAtividade
